import {CampaignList} from "./CampaignList";
import {CampaignEdit} from "./CampaignEdit";
import {CampaignCreate} from "./CampaignCreate";

export default {
    list: CampaignList,
    create:CampaignCreate,
    edit:  CampaignEdit
};
